const $card = $('.m-card');
const $modal = $('.m-card-modal');

const activeModifier = 'm-card--active';
const inactiveModifier = 'm-card--inactive';

$modal.append(`<div class="m-card-modal__close js-close-modal"></div>`);

$card.on('click', function() {
  const $target = $(this);
  const isOpened = $target.hasClass(activeModifier);

  // reset all
  $card.addClass(inactiveModifier).removeClass(activeModifier);
  $modal.hide();

  if (isOpened) {
    $card.removeClass(inactiveModifier);
    return;
  }

  // apply for current
  $target
    .addClass(activeModifier)
    .removeClass(inactiveModifier)
    .find('.m-card-modal').show();
});


$modal.on('click', '.js-close-modal', function(e) {
  e.stopPropagation();
  $modal.hide();
  $card.removeClass(inactiveModifier).removeClass(activeModifier);
});
